import { observer } from "mobx-react-lite";
import { useAlarmWizardStore } from "../useAlarmWizardStore";
import { Button } from "@/components/ui/button";
import { useStore } from "@/hooks/useStore";

export const AlarmWizardFotter = observer(() => {
	const state = useAlarmWizardStore();
	const {
		uiStore: { modalStore },
	} = useStore();
	const { isLastStep, currentStep, wizarType, isLoading } = state;
	const isCreate = wizarType === "create";
	const nextButtonTeext = !isLastStep
		? "Continue"
		: isLoading
			? isCreate
				? "Creating Alarm..."
				: "Updating Alarm..."
			: isCreate
				? "Create Alarm"
				: "Update Alarm";
	return (
		<div className="flex items-center justify-between border-t px-6 py-4 shrink-0 bg-muted/30">
			<div>
				{currentStep > 0 && (
					<Button variant="outline" onClick={() => state.goBack()} disabled={isLoading}>
						Back
					</Button>
				)}
			</div>
			<div className="flex items-center gap-2">
				<Button variant="ghost" onClick={() => modalStore.close()} disabled={isLoading}>
					Cancel
				</Button>
				<Button onClick={() => state.goNext()} disabled={isLoading}>
					{nextButtonTeext}
				</Button>
			</div>
		</div>
	);
});
